export default __webpack_public_path__ + "d8a1833fbf78137ae26d3a617901272b.png";